export default __webpack_public_path__ + "static/media/user-email.3b2103a0.svg";